import { ApplicationRef, ComponentRef, Injector } from '@angular/core';
import { ComponentPortal, DomPortalOutlet } from '@angular/cdk/portal';
import { PageFilterOpenOptions, PageFilterRef } from './types/page-filter.ref';
import { PageFilterComponent } from './components/page-filter/page-filter.component';
import { PageFilterService } from './services/page-filter.service';
import { FilterTemplateService } from '../services/filter-template.service';

export class PageFilter implements PageFilterRef {

  private outlet: DomPortalOutlet;
  private ref:  ComponentRef<PageFilterComponent> | null = null;

  readonly opened = this.service.opened.asReadonly();
  readonly templateService = this.options.templateService ?? null;

  constructor(
    readonly service: PageFilterService,
    private readonly options: {
      injector: Injector,
      appRef: ApplicationRef,
      templateService?: FilterTemplateService | null
    }) {
    this.outlet = new DomPortalOutlet(
      document.body,   // or document.documentElement for the literal <html> root  // ComponentFactoryResolver — not needed on modern Angular
      this.options.appRef,
      this.options.injector,
    );
  }

  open(options?: PageFilterOpenOptions): void {
    if(!this.ref) {
      const injector = Injector.create({
        parent: this.options.injector,
        providers: [
          { provide: PageFilterService, useValue: this.service },
          { provide: FilterTemplateService, useValue: this.options.templateService ?? null }
        ]
      })
      const portal = new ComponentPortal(PageFilterComponent, null, injector);
      this.ref = this.outlet.attach(portal);
    }
    this.service.view.set(options?.view ?? 'filter');
    const item = options?.item ?? null;
    if(item)
      this.service.tab.set('list');
    this.service.selectedItem.set(item && !item.toggle ? item : null);
    this.service.focusedItem.set(item?.toggle ? item : null);
    this.service.opened.set(true);
  }

  close(): void {
    this.service.opened.set(false);
  }

  dispose(): void {
    if(!this.ref)
      return;
    // CDK appended the component's root node to document.body and its dispose fn only
    // detaches the view, so the dead node has to go explicitly. NOT outlet.dispose():
    // that removes the outlet element itself, which here IS document.body.
    const rootNode = this.ref.location.nativeElement as HTMLElement;
    this.outlet.detach();
    rootNode.remove();
    this.ref = null;
  }
}
